import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

interface UseDeleteMaintenanceSolicitationProps {
  id: string
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: ErrorResponse) => void
}

export const useDeleteMaintenanceSolicitation = ({ id, onSuccess, onError }: UseDeleteMaintenanceSolicitationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deleteMaintenanceSolicitation'],
    mutationFn: () => privateAxios.delete(`/maintenance/solicitations/${id}`),
    onSuccess,
    onError,
  })
}
